import { SERIES_TYPE_LABELS, SERIES_TYPES } from "../../../data/chart";
import { SeriesType } from "../../../types/types";
import { Button } from "../../shared/Button";

type SeriesTypeToggleProps = {
	value: SeriesType;
	onChange: (value: SeriesType) => void;
};

export function SeriesTypeToggle({ value, onChange }: SeriesTypeToggleProps) {
	return (
		<div className="pf-series-type-toggle" role="group" aria-label="Pump type">
			{SERIES_TYPES.map((type) => (
				<Button
					key={type}
					variant={value === type ? "primary" : "secondary"}
					aria-pressed={value === type}
					onClick={() => onChange(type)}
				>
					<span>{SERIES_TYPE_LABELS[type]}</span>
				</Button>
			))}
		</div>
	);
}
